import './calls.less';
import React from 'react';
import {inject, observer} from 'mobx-react';

import {Loading} from '../../../common/loading';
import {CallItem} from './call-item';
import {PageFooterNav} from '../common/page-footer-nav';

@inject("callStore")
@inject("loginStore")
@observer
export class Calls extends React.Component {

  componentDidMount() {
    const query = new URLSearchParams(this.props.location.search);

    let page = 1, pageSize = 50;

    if (query.get('page')) {
      page = parseInt(query.get('page'));
    }
    if (query.get('pageSize')) {
      pageSize = parseInt(query.get('pageSize'));
    }

    this.props.callStore.resetFilters();
    this.props.callStore.changePageAndLoad(page, pageSize);
  }

  render() {
    const { isLoading, loadError, calls, total, page, pageSize, filters } = this.props.callStore;

    return (
      <div className="calls-page">

        <div className="calls-list-wrapper">
          <h1>Звонки</h1>

          {isLoading && <Loading />}
          {!isLoading && loadError && (
            <div className="call-load-error">
              Ошибка загрузки: {loadError}
            </div>
          )}
          {!isLoading && !loadError && (
            <React.Fragment>
              <div className="calls-list">
                <div>
                  <div className="call-item call-item-header">
                    <div className="call--state"></div>
                    <div className="call--date">Дата и Время</div>
                    <div className="call--type">Тип звонка</div>
                    <div className="call--status">Статус звонка</div>
                    <div className="call--source">Сайт</div>
                    <div className="call--contact_phone">Номер абонента</div>
                    <div className="call--contact_status">Статус абонента</div>
                    <div className="call--contact_name">Имя абонента</div>
                    <div className="call--duration">Длительность</div>
                    <div className="call--comment">Комментарий</div>
                  </div>

                  {calls.map(call => <CallItem call={call} key={call.id} /> )}
                </div>
              </div>

            </React.Fragment>
          )}


          <PageFooterNav
            page={page}
            pageSize={pageSize}
            total={total}
            onChangePagination={this.onChangePagination}

            filters={filters}
            patchFilters={data => this.props.callStore.patchFilters(data)}
            applyFilters={() => this.props.callStore.load()}
          />
        </div>
      </div>
    );
  }

  onChangePagination = (page, pageSize) => {
    this.props.callStore.changePageAndLoad(page, pageSize);
    this.props.history.push(`?page=${page}&pageSize=${pageSize}`);
  };


}



// WEBPACK FOOTER //
// ./src/components/pages/crm/call/calls.js